import React, { useMemo, useCallback } from 'react'
import { InfoWMO } from '@usap/uicomponents'
import ReturnDetailsItemInfoWMO from './ReturnDetailsItemInfoWMO'
import ReturnReasonsWMO from './ReturnReasonsWMO'
import { 
  Container,
  LeftSection,
  Label,
  Value,
  VerticalLine,
  ShippingInstructionSection,
  DownloadShippingLabelCTA,
  DownloadLabelWrapper,
  TextBox,
  ReturnCTA,
  HorizontalLine,
  AdditionalInfoSection,
  FlexBox
 } from './style/ReturnStatusWMO.css'
import PrepaidShippingLabelWMO from './ShippingLabelInstructions/PrepaidShippingLabelWMO'
import OwnShippingLabelWMO from './ShippingLabelInstructions/OwnShippingLabelWMO'

const ReturnStatusWMO = ({
  orderDetails,
  isDesktop,
  exitReturnDetails
}) => {
  const {
    item,
  } = orderDetails

  const showShippingInstructions = Boolean(item.shipping?.label || (item.credit?.statusCode === '3005' || item.credit?.statusCode === '3010') && item?.returnAddress)

  const idTypeDisplay = useMemo(() => {
    const { rmaId, returnRequestId, creditId } = item

    if (rmaId && rmaId !== 'GP RMA not received.') {
      return (
        <Label>RMA ID: &nbsp;
          <Value>{ rmaId }</Value>
        </Label>
      )
    }

    if (creditId) {
      return (
        <Label>Credit ID: &nbsp;
          <Value>{ creditId }</Value>
        </Label>
      )
    }

    return (
      <Label>Return Request ID: &nbsp;
        <Value>{ returnRequestId }</Value>&nbsp;
        <em color='dark-2' style={{ fontSize: "14px", fontWeight: 400, lineHeight: "165%" }}>
          * This is not your RMA number
        </em>
      </Label>
    )
  }, [item])

  const openShippingLabelDownloadLink = useCallback(() => {
    const { shipping } = item
    window.open(shipping.label)
  }, [item])

  const displayShippingLabelDownloadButton = useMemo(() => {
    const { shipping } = item
    if (!shipping) {
      return null
    }
    if (typeof shipping.label !== 'undefined') {
      const d = new Date(shipping.expiryDate)
      const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      }
      const expiryDate = d.toLocaleDateString('en-US', options)
      return (
        <DownloadLabelWrapper>
          <DownloadShippingLabelCTA
            id="ReturnDetails-DownloadShippingLabel"
            type="submit"
            onClick={openShippingLabelDownloadLink}
          >
            Download Shipping Label
          </DownloadShippingLabelCTA>
          <TextBox>
            <div>
              <InfoWMO />
            </div>
            <p>
              Please ship your part(s) by&nbsp;
              <strong>{expiryDate}</strong>
              &nbsp;to avoid return cancellation
            </p>
          </TextBox>
        </DownloadLabelWrapper>
      )
    }

    return null
  }, [item])

  const displayReturnAddress = useMemo(() => {
    const { returnAddress, credit, shipping } = item
    if (returnAddress && credit.statusCode === '3005' && !shipping) {
      const {
        address,
        city,
        state,
        zip,
      } = returnAddress
      const addressDisplay = `${address}, ${city}, ${state}, ${zip}`
      return (
        <div style={{ marginTop: "16px" }}>
          <Label>
            Return Address:&nbsp;
            <br />
          </Label>
          <Value>{ addressDisplay }</Value>
        </div>
      )
    }

    return null
  }, [item])

  const displayShippingLabelInstruction = useMemo(() => {
    const { credit, shipping, returnAddress } = item
    if (shipping?.label) {
      return (
        <PrepaidShippingLabelWMO />
      )
    }
    if ((credit.statusCode === '3005' || credit.statusCode === '3010') && returnAddress) {
      const {
        address,
        city,
        state,
        zip,
      } = returnAddress
      const addressDisplay = `${address}, ${city}, ${state}, ${zip}`
      return (
        <OwnShippingLabelWMO addressDisplay={addressDisplay} />
      )
    }

    return null
  }, [item])

  const displayPricing = useMemo(() => {
    const { credit } = item

    if(credit?.callTagFee > 0) {
      return (
        <FlexBox>
          <Label>Return Shipping: &nbsp;</Label>
          <Value style={{ color: "#C33"}}>
            - $
            { credit.callTagFee.toFixed(2) }
          </Value>
        </FlexBox>
      )
    }

    if(credit?.total > 0) {
      return (
        <FlexBox>
          <Label>Your Refund: &nbsp;</Label>
          <Value>
            $
            { credit.total.toFixed(2) }
          </Value>
        </FlexBox>
      )
    }

    return null
  }, [item])

  return (
    <>
    <Container>
      <LeftSection hasShippingInstructions={showShippingInstructions}>
        <ReturnDetailsItemInfoWMO orderDetails={orderDetails} isDesktop={isDesktop} />
        <AdditionalInfoSection>
          { idTypeDisplay }
          { displayPricing }
          { displayReturnAddress }
        </AdditionalInfoSection>
        <ReturnReasonsWMO orderDetails={orderDetails} isDesktop={isDesktop} />
      </LeftSection>
      {showShippingInstructions && 
        <>
          <VerticalLine />
          <ShippingInstructionSection>
            {displayShippingLabelInstruction}
            {displayShippingLabelDownloadButton}
          </ShippingInstructionSection>
        </> 
      }
    </Container>
    {item.shipping?.label && <HorizontalLine />}
    <ReturnCTA type='button' onClick={exitReturnDetails}>
      Done
    </ReturnCTA>
    </>
  )
}

export default ReturnStatusWMO